<template>
  <v-row v-if="!loading">
    <v-col cols="12">
      <CPTTextArea
        v-model="inscricaoLocal.observacao"
        auto-grow
        label="Observação"
        outlined
        rounded
      />
    </v-col>
    <v-col v-if="inscricaoLocal.tipo === 'TRANSFERENCIA'" cols="12">
      <CPTTextArea
        v-model="inscricaoLocal.observacao_transferencia"
        auto-grow
        label="Observação de Transferência"
        outlined
        readonly
        rounded
      />
    </v-col>
  </v-row>
  
  <v-row v-else>
    <v-col cols="12">
      <v-skeleton-loader type="paragraph" />
    </v-col>
  </v-row>
</template>

<script>
import CPTTextArea from "@/components/TextArea";

export default {
  name: "secao-06-observacao",

  components: {
    CPTTextArea,
  },

  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    inscricaoLocal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
